/**
 * Derives a human-readable display name from an email's local-part.
 *
 * The PM `migrationCandidateUserBody` supplies only an `email` — no `name` —
 * so the Suggested Users review modal derives a display name client-side
 * (SPEC.md Q3b) instead of designing around a field the API can't supply.
 *
 * Splits the local-part on `.`, `_`, and `-`, then title-cases each segment
 * (capitalizes the first character, lowercases the rest):
 * `john.doe@example.com` -> `John Doe`, `JANE_SMITH@x.com` -> `Jane Smith`.
 */
export function deriveNameFromEmail(email: string): string {
  const [localPart] = email.split('@');

  return localPart
    .split(/[._-]+/)
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase())
    .join(' ');
}
